import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';

export const StyledChildrenWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  flex-grow: 1;
  height: 100%;
  overflow: hidden;

  svg {
    margin-right: ${globalTheme.spacing.xs};
    transition: fill 150ms;
    flex-shrink: 0;
    color: currentColor;
  }
`;

export default StyledChildrenWrapper;
